'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPanTool = function MdPanTool(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.4 9.1v24.3c0 3.6-3.1 6.6-6.8 6.6h-12.1c-1.8 0-3.5-0.7-4.7-2l-13.2-13.3s2.2-2 2.2-2c0.4-0.4 0.9-0.5 1.4-0.5 0.3 0 0.7 0.1 1 0.2 0.1 0 7.2 4.1 7.2 4.1v-19.9c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v11.8h1.6v-15.9c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v15.9h1.6v-14.3c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v14.3h1.8v-9.3c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5z' })
        )
    );
};

exports.default = MdPanTool;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/pan-tool.js
// module id = 3362
// module chunks = 0